import script from "./OrderGroupBulkChangeETAModalContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderGroupBulkChangeETAModalContent.vue?vue&type=script&setup=true&lang=ts"

import "./OrderGroupBulkChangeETAModalContent.vue?vue&type=style&index=0&id=7146b789&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7146b789"]])

export default __exports__